import React, { useState } from "react";
import { Form, Input, Button, Select, Row, Col, Typography, Card, Upload, message, DatePicker } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import appColors from "../../config/appColors";
import { postRequestFormData } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import Sidebar from "../../Components/Sidebar/sidebar";


import VehicleView from "../../Components/VehicleView";
import { selectStyle } from "../../css/styles";
import RichTextEditor from "../../Components/RichTextEditor";
const { Option } = Select;
const { Title } = Typography;

const AddVehicle = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.authReducer.user);

  const [images, setImages] = useState([]);

  const [vehicleName, setVehicleName] = useState("");
  const [regNo, setRegNo] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");
  const [seats, setSeats] = useState("");
  const [transmission, setTransmission] = useState("");
  const [bodyType, setBodyType] = useState("");
  const [color, setColor] = useState("");
  const [ac, setAC] = useState("0");
  const [fuelType, setFuelType] = useState("");
  const [mileage, setMileage] = useState("");
  const [rent, setRent] = useState("");
  const [rentalDetails, setRentalDetails] = useState("");

  const [licenseExpDate, setLicenseExpDate] = useState(null);
  const [motTestDate, setMotTestDate] = useState(null);
  const [motExpDate, setMotExpDate] = useState(null);
  const [taxExpDate, setTaxExpDate] = useState(null);
  const [pcoTestDate, setPCOTestDate] = useState(null);
  const [pcoExpDate, setPCOExpDate] = useState(null);

  const [fileList, setFileList] = useState([]);

  const [documentList, setDocumentList] = useState([]); // [{ uid, name, originFileObj, docType }]

  const [imageFileList, setImageFileList] = useState([]);

  const handleMotTestDateChange = (date) => {
    setMotTestDate(date);
    if (date) {
      setMotExpDate(date.add(12, "month")); // UK MOT usually 12 months
    } else {
      setMotExpDate(null);
    }
  };
  const handlePCOTestDate = (date) => {
    setPCOTestDate(date);
    if (date) {
      setPCOExpDate(date.add(12, "month")); // UK MOT usually 12 months
    } else {
      setPCOExpDate(null);
    }
  };

  const onFinish = async () => {
    // Validation
    // if (imageFileList.length === 0) {
    //   return message.error("Please upload at least one vehicle image");
    // }
    if (!images.length) {
      message.error('Please add atleast one vehicle image');
      return;
    }
    if (!vehicleName || !regNo || !make || !model || !year || !transmission ||
      !fuelType || !seats || !rent || !bodyType || !rentalDetails) {
      return message.error("Please fill all required fields");
    }

    // Direct FormData banao
    const formData = new FormData();

    // Basic fields
    formData.append("token", user?.token);
    formData.append("veh_name", vehicleName);
    formData.append("reg_no", regNo.toUpperCase());
    formData.append("make", make);
    formData.append("model", model);
    formData.append("year", year);
    formData.append("transmission", transmission);
    formData.append("milage", mileage || "");
    formData.append("fuel_type", fuelType);
    formData.append("seats", seats);
    formData.append("rent", rent);
    formData.append("body_type", bodyType);
    formData.append("rental_details", rentalDetails);
    formData.append("ac", ac);
    formData.append("color", color || "");

    // Dates
    if (licenseExpDate) formData.append("license_exp_date", licenseExpDate.format("YYYY-MM-DD"));
    if (motTestDate) formData.append("mot_test_date", motTestDate.format("YYYY-MM-DD"));
    if (motExpDate) formData.append("mot_exp_date", motExpDate.format("YYYY-MM-DD"));
    if (pcoTestDate) formData.append("pco_test_date", pcoTestDate.format("YYYY-MM-DD"));
    if (pcoExpDate) formData.append("pco_exp_date", pcoExpDate.format("YYYY-MM-DD"));
    if (taxExpDate) formData.append("tax_exp_date", taxExpDate.format("YYYY-MM-DD"));

    // Images append
    console.log('image', images);
    for (let key1 of images) {
      formData.append('images[]', key1);
    }
    // images.forEach((file) => {
    //   formData.append("images[]", file);
    // });

    // Documents append + types
    documentList.forEach((doc) => {
      formData.append("documents[]", doc.originFileObj);
      formData.append("doc_type[]", doc.docType || "other");
    });

    dispatch(setLoader(true));

    // Direct FormData pass karo
    await postRequestFormData(
      formData, // ye FormData hai
      apiRoutes.addVehicle,
      () => {
        dispatch(setLoader(false));
        message.success("Vehicle added successfully with documents!");
        navigate("/vehicles");
      },
      (err) => {
        dispatch(setLoader(false));
        message.error(err?.error ?? "Failed to add vehicle");
      }
    );
  };


  // const onFinish = async () => {
  //   if (!images.length) {
  //     message.error('Please add atleast one vehicle image');
  //     return;
  //   }

  //   if (!vehicleName || !regNo || !make || !model || !year || !transmission ||
  //     !fuelType || !seats || !rent || !bodyType || !rentalDetails) {
  //     return message.error("Please fill all required fields");
  //   }
  //   const payload = {
  //     token: user?.token,
  //     veh_name: vehicleName,
  //     reg_no: regNo.toUpperCase(),
  //     make,
  //     model,
  //     year,
  //     transmission,
  //     milage: mileage || "",
  //     fuel_type: fuelType,
  //     seats,
  //     rent,
  //     body_type: bodyType,
  //     rental_details: rentalDetails,
  //     ac,
  //     color: color || "",
  //     'images[]': images,

  //   };

  //   if (licenseExpDate) payload.license_exp_date = licenseExpDate.format("YYYY-MM-DD");
  //   if (motTestDate) payload.mot_test_date = motTestDate.format("YYYY-MM-DD");
  //   if (motExpDate) payload.mot_exp_date = motExpDate.format("YYYY-MM-DD");
  //   if (pcoTestDate) payload.pco_test_date = pcoTestDate.format("YYYY-MM-DD");
  //   if (pcoExpDate) payload.pco_exp_date = pcoExpDate.format("YYYY-MM-DD");
  //   if (taxExpDate) payload.tax_exp_date = taxExpDate.format("YYYY-MM-DD");


  //   // ✅ VERY IMPORTANT PART

  //   // payload["images[]"] = fileList.map(file => file.originFileObj);
  //   // console.log('images', fileList);
  //   // return;
  //   dispatch(setLoader(true));

  //   await postRequestFormData(
  //     payload,
  //     apiRoutes.addVehicle,
  //     () => {
  //       dispatch(setLoader(false));
  //       message.success("Vehicle added successfully!");
  //       navigate("/vehicles");
  //     },
  //     (err) => {
  //       dispatch(setLoader(false));
  //       message.error(err?.error ?? err?.data?.error ?? "Failed to add vehicle");
  //     }
  //   );
  // };

  const documentUploadProps = {
    onRemove: (file) => {
      setDocumentList((prev) => prev.filter((item) => item.uid !== file.uid));
    },
    beforeUpload: (file) => {
      const newFile = {
        uid: file.uid,
        name: file.name,
        status: 'done',
        originFileObj: file,
        docType: 'other' // default
      };
      setDocumentList((prev) => [...prev, newFile]);
      return false; // prevent auto upload
    },
    fileList: documentList,
    multiple: true,
    listType: "text",
    showUploadList: false, // hum custom list banayenge neeche
  };

  // Function to change document type
  const handleDocTypeChange = (value, uid) => {
    setDocumentList((prev) =>
      prev.map((doc) => (doc.uid === uid ? { ...doc, docType: value } : doc))
    );
  };


  const imageUploadProps = {
    onRemove: (file) => {
      setImageFileList((prev) => prev.filter((item) => item.uid !== file.uid));
    },
    beforeUpload: (file) => {
      setImageFileList((prev) => [...prev, file]);
      return false;
    },
    fileList: imageFileList,
    listType: "picture-card",
    multiple: true,
  };

  const uploadProps = {
    onRemove: (file) => {
      setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
    },
    beforeUpload: (file) => {
      setFileList((prev) => [...prev, file]);
      return false; // Prevent auto upload
    },
    fileList,
    listType: "picture-card",
    multiple: true,
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: "#f0f2f5" }}>
      <Sidebar />

      <div style={{ flexGrow: 1, padding: "24px" }}> {/* Sidebar ke baad start */}
        <Title level={2} style={{ marginBottom: 24 }}>
          Add New Vehicle
        </Title>

        <Card
          title={<Title level={4} style={{ color: "white", margin: 0 }}>Vehicle Information</Title>}
          headStyle={{ backgroundColor: appColors.primary, borderRadius: "8px 8px 0 0" }}
          bodyStyle={{ padding: "32px" }}
        >
          <Form layout="vertical" onFinish={onFinish}>
            <Row gutter={[16, 16]}>
              {/* Row 1 */}
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Vehicle Name" required>
                  <Input value={vehicleName} onChange={(e) => setVehicleName(e.target.value)} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Registration No" required>
                  <Input value={regNo} onChange={(e) => setRegNo(e.target.value.toUpperCase())} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Make" required>
                  <Input value={make} onChange={(e) => setMake(e.target.value)} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Model" required>
                  <Input value={model} onChange={(e) => setModel(e.target.value)} />
                </Form.Item>
              </Col>

              {/* Row 2 */}
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Year" required>
                  <Input type="number" value={year} onChange={(e) => setYear(e.target.value)} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Seats" required>
                  <Input type="number" value={seats} onChange={(e) => setSeats(e.target.value)} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Transmission" required>
                  <Select value={transmission} onChange={setTransmission}>
                    <Option value="Manual">Manual</Option>
                    <Option value="Automatic">Automatic</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Body Type" required>
                  <Select value={bodyType} onChange={setBodyType}>
                    <Option value="SUV">SUV</Option>
                    <Option value="Sedan">Sedan</Option>
                    <Option value="Compact car">Compact Car</Option>
                    <Option value="City car">City Car</Option>
                  </Select>
                </Form.Item>
              </Col>

              {/* Row 3 */}
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Color">
                  <Input value={color} onChange={(e) => setColor(e.target.value)} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="AC">
                  <Select value={ac} onChange={setAC}>
                    <Option value="1">Yes</Option>
                    <Option value="0">No</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Fuel Type" required>
                  <Select value={fuelType} onChange={setFuelType}>
                    <Option value="Petrol">Petrol</Option>
                    <Option value="Diesel">Diesel</Option>
                    <Option value="Petrol hybrid PHEV">Petrol Hybrid (PHEV)</Option>
                    <Option value="Electric">Electric</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Mileage (miles)">
                  <Input value={mileage} onChange={(e) => setMileage(e.target.value)} />
                </Form.Item>
              </Col>

              {/* Dates */}
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="License Exp Date">
                  <DatePicker
                    style={{ width: "100%" }}
                    value={licenseExpDate}
                    onChange={setLicenseExpDate}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="MOT Test Date">
                  <DatePicker
                    style={{ width: "100%" }}
                    value={motTestDate}
                    onChange={handleMotTestDateChange}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="MOT Exp Date">
                  <Input
                    value={motExpDate ? motExpDate.format("DD/MM/YYYY") : ""}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="Tax Exp Date">
                  <DatePicker
                    style={{ width: "100%" }}
                    value={taxExpDate}
                    onChange={setTaxExpDate}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="PCO Test date">
                  <DatePicker
                    style={{ width: "100%" }}
                    value={pcoTestDate}
                    onChange={handlePCOTestDate}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label="PCO Exp date">
                  <DatePicker
                    style={{ width: "100%" }}
                    value={pcoExpDate}
                    disabled

                  />
                </Form.Item>
              </Col>

              {/* Rent & Details */}
              <Col xs={24} md={12}>
                <Form.Item label="Daily Rent (£)" required>
                  <Input type="number" value={rent} onChange={(e) => setRent(e.target.value)} />
                </Form.Item>
              </Col>
              <Col xs={24} md={18}>
                <Form.Item label="Rental Details" required>
                  <Input.TextArea rows={4} value={rentalDetails} onChange={(e) => setRentalDetails(e.target.value)} />
                </Form.Item>
              </Col>

              {/* Images */}
              <Col xs={24}>
                <Form.Item label="Vehicle Images (Multiple)" required>
                  <input type="file" multiple onChange={(e) => setImages(e.target.files)} />
                </Form.Item>
              </Col>
              {/* <Col xs={24}>
                <Form.Item label="Vehicle Images (Multiple)" required>
                  <Upload {...imageUploadProps}>
                    <Button icon={<UploadOutlined />}>Upload Images</Button>
                  </Upload>
                </Form.Item>
              </Col> */}

              {/* Vehicle Documents Section - Clean & Professional */}
              <Col xs={24}>
                <Form.Item label="Vehicle Documents (Optional)">
                  <Upload {...documentUploadProps}>
                    <Button icon={<UploadOutlined />} size="large">
                      Upload Documents (PDF, JPG, PNG)
                    </Button>
                  </Upload>

                  {/* Custom List - Har file ke saath type dropdown */}
                  {documentList.length > 0 && (
                    <div style={{ marginTop: 20, border: "1px solid #d9d9d9", borderRadius: 8, padding: 16, backgroundColor: "#fafafa" }}>
                      <Title level={5} style={{ marginBottom: 16 }}>Uploaded Documents</Title>

                      {documentList.map((file) => (
                        <Row
                          key={file.uid}
                          gutter={16}
                          align="middle"
                          style={{
                            marginBottom: 12,
                            padding: "12px 8px",
                            backgroundColor: "white",
                            borderRadius: 6,
                            border: "1px solid #e8e8e8"
                          }}
                        >
                          <Col flex="auto">
                            <div>
                              <strong>{file.name}</strong>
                              <div style={{ fontSize: 12, color: "#888" }}>
                                {(file.originFileObj.size / 1024 / 1024).toFixed(2)} MB
                              </div>
                            </div>
                          </Col>

                          <Col flex="250px">
                            <Select
                              value={file.docType || "other"}
                              style={{ width: "100%" }}
                              onChange={(value) => handleDocTypeChange(value, file.uid)}
                              placeholder="Select document type"
                            >
                              <Option value="mot_certificate">MOT Certificate</Option>
                              <Option value="mot_test_report">MOT Test Report</Option>
                              <Option value="pco_license">PCO License</Option>
                              <Option value="pco_test_report">PCO Test Report</Option>
                              <Option value="insurance">Insurance Policy</Option>
                              <Option value="road_tax">Road Tax (V11)</Option>
                              <Option value="vehicle_license">V5C Log Book</Option>
                              <Option value="service_history">Service History</Option>
                              <Option value="phv_license">PHV License</Option>
                              <Option value="other">Other</Option>
                            </Select>
                          </Col>

                          <Col flex="60px" style={{ textAlign: "right" }}>
                            <Button
                              danger
                              size="small"
                              onClick={() => {
                                setDocumentList((prev) => prev.filter((item) => item.uid !== file.uid));
                              }}
                            >
                              Remove
                            </Button>
                          </Col>
                        </Row>
                      ))}
                    </div>
                  )}

                  {documentList.length === 0 && (
                    <div style={{ marginTop: 8, color: "#888", fontStyle: "italic" }}>
                      No documents uploaded yet
                    </div>
                  )}
                </Form.Item>
              </Col>

              {/* Submit */}
              <Col xs={24} style={{ textAlign: "center" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  style={{ width: 200, height: 48, fontSize: 16, backgroundColor: appColors.primary }}
                >
                  Add Vehicle
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default AddVehicle;
